import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Form from "antd/es/form/index.js";
import { validationError } from '../validation-error/';
import { childrenPropTypes } from '@data-driven-forms/common/prop-types-templates';

var FormGroup = function FormGroup(_ref) {
  var label = _ref.label,
      children = _ref.children,
      isRequired = _ref.isRequired,
      FormItemProps = _ref.FormItemProps,
      meta = _ref.meta,
      validateOnMount = _ref.validateOnMount,
      helperText = _ref.helperText,
      description = _ref.description,
      hideLabel = _ref.hideLabel;
  var invalid = validationError(meta, validateOnMount);
  var warning = (meta.touched || validateOnMount) && meta.warning;
  var help = invalid || warning || helperText || description;
  return /*#__PURE__*/React.createElement(Form.Item, _extends({
    validateStatus: !invalid ? warning ? 'warning' : '' : 'error',
    help: help,
    label: !hideLabel && label,
    required: isRequired
  }, FormItemProps), children);
};

FormGroup.propTypes = {
  label: PropTypes.string,
  children: childrenPropTypes,
  help: PropTypes.string,
  isRequired: PropTypes.bool,
  invalid: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  FormItemProps: PropTypes.object,
  meta: PropTypes.object,
  validateOnMount: PropTypes.bool,
  helperText: PropTypes.node,
  description: PropTypes.node,
  hideLabel: PropTypes.bool
};
export default FormGroup;